import {
  getAeLeadSourcesFormField,
  getBaseSalaryFormField,
  getOteFormField,
  getQuotaAttinmentByTeamFormField,
  getRankOnTeamFormField,
  getRevenueFormField,
  getSalesCycleLengthFormField,
  getSalesMethodologiesFormField,
  getTeamSizeFormField,
} from '@/components/partials/jobs/JobsInquiryForm/utils/formFields';
import type {
  JobsFormField,
  JobsSectionModels,
} from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/types';

export default ({ inquiry }: JobsSectionModels): JobsFormField[] => {
  return [
    getBaseSalaryFormField({ inquiry }),
    getOteFormField({ inquiry }),
    getRevenueFormField({ inquiry }),
    getSalesCycleLengthFormField(),
    getRankOnTeamFormField(),
    getTeamSizeFormField(),
    getQuotaAttinmentByTeamFormField(),
    getAeLeadSourcesFormField(inquiry),
    getSalesMethodologiesFormField(),
  ];
};
